import * as React from "react";
import { ContextStore } from "../../../../../../../../react-core/Flux/Variables";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { Spinner } from "../../../../../../../../react-core/Html/Spinner";
import { ContextType } from "../../../../../../../../Wrap/Constants/Enums/ContextType";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import { Navigator } from "../../../../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Urls } from "../../../../../../Urls";
import { ReportReadyIcon } from "./ReportReadyIcon";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";

interface IReportReadyProps {
    pending: boolean;
    isFailed: boolean;
    url: string;
}

interface IReportReadyState {}

export class ReportReady extends FormComponent<IReportReadyProps, IReportReadyState> {
    constructor(props: IReportReadyProps) {
        super(props);
    }

    render() {
        if (this.props.pending) {
            return (
                <div className="text-center">
                    <h3>Generating your report</h3>
                    <p>
                        This can take a few moments. When completed, the report will be saved to your client's document
                        store.
                    </p>
                    <Spinner notFull={true} />
                </div>
            );
        }
        return (
            <>
                <div className="text-center mb-54">
                    <h2>{this.props.isFailed ? "Generate Failed or Cancelled" : "Report ready"}</h2>
                    {!this.props.isFailed && (
                        <>
                            {" "}
                            <p>
                                This report has now been created and saved to your{" "}
                                {(checkPermission(UserClaim.AdviserPortalDocumentLibraryCanView) ? (
                                        <a
                                            className="hyperlink"
                                            href={`javascript:void(0);`}
                                            onClick={() => {
                                                Navigator.navigateTo(
                                                    Urls.get().main.PortfolioDashboard({
                                                        hierarchyId: ContextStore.getUrlParamsHierarchyId(
                                                            ContextType.Customer
                                                        ),
                                                    }).documents,
                                                    {
                                                        scrollAfterNavigating: true,
                                                        queryParamsObject: {
                                                            hierarchyid: ContextStore.getUrlParamsHierarchyId(
                                                                ContextType.Account
                                                            ),
                                                        },
                                                    }
                                                );
                                            }}
                                        >
                                            client`s document store
                                        </a>
                                    ) : (
                                        "client`s document store"
                                    ))}
                                .
                            </p>
                            <a
                                type="button"
                                className="hyperlink download-button"
                                target={"_blank"}
                                href={this.props.url}
                            >
                                <span className="icon" aria-hidden="true"></span>
                                <span className="text">Client Portfolio Report</span>
                            </a>
                            <ReportReadyIcon cssWrapper="large" url={this.props.url} />
                        </>
                    )}
                    {this.props.isFailed && <p>error message placeholder</p>}
                </div>
                <h2 className="mt-10">Quick links</h2>
                <hr className="mb-10" />
                {checkPermission(UserClaim.AdviserPortalClientPortfolioReportReadWrite) && (
                    <div>
                        <button
                            className="hyperlink"
                            onClick={() => {
                                window.location.assign(
                                    `/wpadviser/en-gb/dashboard/home/main/customer/${ContextStore.getUrlParamsHierarchyId(
                                        ContextType.Customer
                                    )}/headaccount/${ContextStore.getUrlParamsHierarchyId(
                                        ContextType.Account
                                    )}/clientreport`
                                );
                            }}
                        >
                            {"Create new report >"}
                        </button>
                    </div>
                )}

                {checkPermission(UserClaim.AdviserPortalClientSummaryCanView) && (
                    <button
                        className="hyperlink"
                        onClick={() => {
                            Navigator.navigateTo(
                                Urls.get().main.PortfolioDashboard({
                                    hierarchyId: ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                                }).summary
                            );
                        }}
                    >
                        {"Return to summary page >"}
                    </button>
                )}
            </>
        );
    }
}
